<template>
  <ConfirmPopup></ConfirmPopup>
  <ConfirmDialog></ConfirmDialog>
  <div class="lista-page">
    <PageHeader title="Territorios" class="noprint">
      <template #actions>
        <Button
          icon="pi pi-plus"
          label="Crear"
          data-e2e="btn-crear-territorio"
          class="noprint"
          @click="newPlane"
        />
        <Button
          icon="pi pi-clone"
          label="Crear varios"
          severity="secondary"
          outlined
          class="noprint"
          data-e2e="btn-crear-territorios-masivo"
          @click="route.$patch({ page: 'crearTerritorios' })"
        />
      </template>
    </PageHeader>
    <div class="lista-card">
      <div class="grid-header flex justify-content-between noprint">
        <IconField iconPosition="left">
          <InputIcon class="pi pi-search"> </InputIcon>
          <InputText
            v-model="filters1['global'].value"
            placeholder="Filtrar"
            data-e2e="input-filtro-territorios"
          />
        </IconField>
      </div>
      <div v-if="filteredTerritorios.length === 0" class="text-center text-gray-400 py-5">
        Ningun registro encontrado
      </div>
      <div class="territorios-grid" v-else>
        <div class="territorio-card" v-for="data in filteredTerritorios" :key="data.id">
          <div class="card-top flex justify-content-between align-items-start gap-2">
            <div>
              <div class="text-lg font-bold">
                {{ data.territorio_nombre }}
              </div>
              <div class="text-sm text-gray-400" v-if="data.tipo === 'routes'">
                Rutas
              </div>
            </div>
            <ColorPicker
              :modelValue="hexFromColor(data.color)"
              @update:modelValue="(val) => updateColor(data, val)"
            />
          </div>
          <div class="card-body">
            <div v-if="data.referencia">{{ data.referencia }}</div>
            <div class="notas" v-if="data.notas">{{ data.notas }}</div>
            <div class="asignado pt-1 text-sm">
              <span
                class="text-accent text-sm"
                v-if="asignados[data.territorio_nombre]"
                >Asignado a
                {{ asignados[data.territorio_nombre].assignedTo }}</span
              >
              <div class="asignar flex flex-column gap-1 mt-1" v-else>
                <a
                  href="#"
                  @click="showAsignar(data.territorio_nombre)"
                  v-if="formAsignar.territorio !== data.territorio_nombre"
                  >Asignar</a
                >
                <div
                  v-if="formAsignar.territorio === data.territorio_nombre"
                  class="flex flex-column gap-1"
                >
                  <label>Asignar a:</label>
                  <input
                    type="text"
                    class="p-2 mb-2"
                    v-model="formAsignar.assignedTo"
                    placeholder="Nombre de Publicador"
                  />
                  <a href="#" @click="asignar">Guardar Asignación</a>
                </div>
              </div>
            </div>
          </div>
          <div class="card-actions flex justify-content-end">
            <SplitButton
              label="Editar"
              severity="secondary"
              @click="edit(data)"
              :model="getSplitOption(data)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <Dialog
    v-model:visible="visibleWork"
    modal
    header="Registro de trabajo"
    style="width: 95vw;"
    >
    <TarjetaTerritorio :isMobile="screen.isMobile" />
  </Dialog>
  <Dialog
    v-model:visible="visibleSalidas"
    modal
    :header="`Últimas salidas — ${salidaTerritorio?.territorio_nombre || ''}`"
    style="width: 95vw; max-width: 600px;"
  >
    <div v-if="ultimasSalidas.length === 0" class="text-center text-gray-400 py-4">
      Sin salidas registradas para este territorio.
    </div>
    <table v-else class="w-full text-sm">
      <thead>
        <tr class="text-left border-bottom-1 surface-border pb-2">
          <th class="pb-2 pr-3">Día</th>
          <th class="pb-2 pr-3">Fecha</th>
          <th class="pb-2 pr-3">Horario</th>
          <th class="pb-2">Conductor</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="s in ultimasSalidas"
          :key="s.id"
          class="border-bottom-1 surface-border"
        >
          <td class="py-2 pr-3 font-medium">{{ getDayName(s.date) }}</td>
          <td class="py-2 pr-3">{{ getLocalDate(s.date) }}</td>
          <td class="py-2 pr-3">{{ s.hour || '-' }}</td>
          <td class="py-2">{{ conductorName(s.conductor) }}</td>
        </tr>
      </tbody>
    </table>
  </Dialog>
</template>

<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import { useConfirm } from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmDialog from "primevue/confirmdialog";

import Dialog from "primevue/dialog";
import TarjetaTerritorio from "./TarjetaTerritorio.vue";
import { ref, computed } from "vue";
import { useRouterStore } from "@/store/router";
import { useTerritoriosStore } from "@/store/territorios";
import { useTerritorioStore } from "@/store/territorio";
import { useMapData } from "@/composables/useMapData";
// import PuntosDeEncuentro from "@/components/PuntosDeEncuentro.vue";
import SplitButton from "primevue/splitbutton";
import ColorPicker from "primevue/colorpicker";
import { getContrastingColor } from "@/composables/color";
import { useScreenStore } from "@/store/useScreenStore";
import { usePresenceStore } from "@/store/usePresenceStore";
import { useApi } from "@/composables/useApi";
import { useStorage } from "@/composables/useStorage";
import { useSalidaStore } from "@/store/useSalidaStore";
// import { ref } from 'vue'
const territorios = useTerritoriosStore();
const territorio = useTerritorioStore();
const screen = useScreenStore();
const route = useRouterStore();
const presenceStore = usePresenceStore();
const api = useApi();
const { saveAssignments } = useStorage();
const salida = useSalidaStore();
const formAsignar = ref({
  territorio: "",
  assignedTo: "",
});
const visibleWork = ref(false);
const visibleSalidas = ref(false);
const salidaTerritorio = ref(null);

const ultimasSalidas = computed(() => {
  if (!salidaTerritorio.value) return [];
  const nombre = salidaTerritorio.value.territorio_nombre;
  const todas = [...(salida.list.data || []), ...(salida.history || [])];
  return todas
    .filter((s) => Array.isArray(s.territorios) && s.territorios.includes(nombre))
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 10);
});

const conductorName = (val) => {
  if (!val) return "-";
  const found = salida.conductores.find((c) => c.id === val);
  return found ? found.name : val;
};

const getDayName = (date) => {
  const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const d = date instanceof Date ? date : new Date(date);
  return days[d.getDay()];
};

const getLocalDate = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString();
};

const showSalidas = (item) => {
  salidaTerritorio.value = item;
  visibleSalidas.value = true;
};

const showAsignar = (territorio) => {
  formAsignar.value = {
    territorio,
    assignedTo: "",
  };
};

const asignar = async () => {
  if (formAsignar.value.assignedTo) {
    const doc = {
      id: new Date().getTime(),
      territorios: [formAsignar.value.territorio],
      assignedTo: formAsignar.value.assignedTo,
      type: "private",
      returnedAt: null,
    };
    territorios.$patch({ asignados: [...territorios.asignados, doc] });
    await saveAssignments();
  } else {
    formAsignar.value = {
      territorio: "",
      assignedTo: "",
    };
  }
};

const { getItemUrl } = useMapData();

const getSplitOption = (data) => {
  // <Button icon="pi pi-pencil" outlined class="noprint"  @click="edit(data)" />
  //             <Button icon="pi pi-history"  severity="success" label="Historial" title="Ver y actualizar trabajo" class="noprint" outlined  @click="terrWork(data)" />
  //             <a :href="getItemUrl(data)" target="_blank" class="btn btn-sm btn-secondary"><Button label="Ver" icon="pi pi-eye" outlined  /></a>
  //             <Button @click="confirm2($event, data)" icon="pi pi-times" outlined severity="danger"></Button>
  return [
    {
      label: "Registro de Trabajo",
      icon: "pi pi-history",
      command: () => terrWork(data),
    },
    {
      label: "Últimas Salidas",
      icon: "pi pi-clock",
      command: () => showSalidas(data),
    },
    // {
    //   label: "Ver Mapa",
    //   icon: "pi pi-eye",
    //   command: () => window.open(getItemUrl(data), "_blank"),
    // },
    {
      label: "Eliminar",
      icon: "pi pi-times",
      command: () => confirm2(null, data),
    },
  ];
};

const hexFromColor = (color) => {
  const bg = color?.backgroundColor || "#ffffff";
  if (bg.startsWith("#")) return bg.slice(1);
  const nums = bg.match(/\d+/g);
  if (nums) {
    return nums
      .slice(0, 3)
      .map((n) => parseInt(n).toString(16).padStart(2, "0"))
      .join("");
  }
  return "ffffff";
};

const updateColor = async (item, hex) => {
  if (!hex) return;
  const raw = territorios.list.find((t) => t.uuid === item.uuid);
  if (!raw) return;
  const updated = {
    ...raw,
    color: {
      backgroundColor: "#" + hex,
      color: getContrastingColor(hex),
    },
  };
  await territorios.update(updated);
  const result = await api.put(`/api/territories/${updated.uuid}`, updated);
  if (result?.error) {
    console.error("Error al guardar color:", result.error);
  }
};

const asignados = computed(() => {
  let data = {};
  for (let i in territorios.asignadosActivos) {
    for (let j in territorios.asignadosActivos[i].territorios) {
      data[territorios.asignadosActivos[i].territorios[j]] = territorios.asignadosActivos[i];
    }
  }
  return data;
});

const newPlane = async () => {
  territorio.$reset();
  await territorio.setId();
  route.$patch({ page: "formTerritorio", params: { id: territorio.uuid } });
};

const filters1 = ref({ global: { value: "" } });

const filteredTerritorios = computed(() => {
  const term = (filters1.value.global.value || "").trim().toLowerCase();
  if (!term) return territorios.listWithName;
  const fields = ["zona", "numero", "referencia", "notas", "territorio_nombre"];
  return territorios.listWithName.filter((item) =>
    fields.some((field) =>
      String(item[field] ?? "").toLowerCase().includes(term)
    )
  );
});
const iframe = ref("null");
const props = defineProps({
  print: { type: Boolean, default: false },
});

const visibleLeft = ref(false);

let activeMode = props.print ? "map" : "list";
// console.log("activeMode", activeMode)
const mode = ref(activeMode);
const modes = ref([
  // {icon: 'pi pi-align-left', value: 'Left'},
  // {icon: 'pi pi-align-right', value: 'Right'},
  { icon: "pi pi-list", value: "list" },
  // {icon: 'pi pi-table', value: 'map'},
  // {icon: 'pi pi-print', value: 'print'},
]);

const doEdit = (item) => {
  const doc = { ...item };
  if (!doc.tipo) doc.tipo = "default";
  territorio.cargar(doc);
  presenceStore.sendPresence("formTerritorio", item.territorio_nombre);
  route.$patch({ page: "formTerritorio", params: { id: item.uuid } });
};

const edit = (item) => {
  const others = presenceStore.othersOnTerritory(item.territorio_nombre);
  if (others.length > 0) {
    const names = others.map((u) => u.email).join(", ");
    confirm.require({
      message: `${names} también está editando este territorio. ¿Deseas continuar de todas formas?`,
      header: "Advertencia de sobreescritura",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Continuar igual",
      rejectLabel: "Cancelar",
      acceptClass: "p-button-warning",
      accept: () => doEdit(item),
    });
    return;
  }
  doEdit(item);
};

const terrWork = (item) => {
  const doc = {
    ...item,
  };
  // console.log("terrWork", doc)
  if (!doc.tipo) doc.tipo = "default";
  territorio.$patch(doc);
  visibleWork.value = true;
  // route.$patch({ page: "tarjetaTerritorio" });
};

const loadIframe = () => {
  // console.log("load iframe")
  var frame = iframe.value;
  frame.contentWindow.postMessage({
    call: "sendList",
    value: JSON.parse(JSON.stringify(territorios.list)),
  });
};

const print = () => {
  window.print();
};
window.addEventListener(
  "message",
  function (event) {
    var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
    // console.log("origen", origin, event)
    if (
      origin !== "http://localhost:8080" &&
      origin !== "https://territorios.web.app"
    )
      return;
    // console.log("origen ok")
    if (typeof event.data == "object" && event.data.call == "sendList") {
      // console.log("message", event.data)
      territorios.$patch({ list: event.data.value });
    }
  },
  false
);

const confirm = useConfirm();
const confirm2 = (event, data) => {
  // console.log("confirm2", event, data)
  confirm.require({
    // target: event.currentTarget,
    message: "¿Quieres eliminar este territorio?",
    header: "Danger Zone",
    icon: "pi pi-info-circle",
    acceptClass: "p-button-danger",
    accept: () => {
      // console.log("aceptado", data)
      const newList = territorios.list.filter((item) => {
        if (item.zona !== data.zona) return true;
        if (item.numero !== data.numero) return true;
        return false;
      });
      territorios.$patch({ list: newList });
      api.del(`/api/territories/${data.uuid}`)
        .catch(e => console.error('Error al eliminar territorio:', e));
    },
    reject: () => {},
  });
};
</script>

<style scoped>
.lista-page {
  width: 100%;
  text-align: left;
}
.lista-card {
  margin: 0 var(--space-5) var(--space-5);
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-1);
  overflow: hidden;
  padding: var(--space-4);
}
.grid-header {
  margin-bottom: var(--space-4);
}
.territorios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: var(--space-4);
}
.territorio-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border: 1px solid var(--separator);
  border-radius: var(--radius-md);
  padding: var(--space-3);
  background: var(--bg-primary);
}
.territorio-card .card-body {
  flex: 1;
}
.territorio-card .card-actions {
  margin-top: auto;
}
a {
  cursor: pointer;
  color: var(--accent) !important;
  text-decoration: none !important;
}
h1, h2 {
  font-weight: var(--weight-medium);
}
div.tarjeta {
  border: 1px solid var(--separator);
  padding: var(--space-2);
  background: var(--bg-primary);
  cursor: pointer;
  height: 100%;
  border-radius: var(--radius-sm);
}
.notas {
  font-size: var(--text-footnote);
}
</style>
